module.exports = "/partner-op5d595138f245525021666f12f89922e24.svg";